import api from "../utils/api";
import { API, API_ENDPOINTS, ApiResponse } from "@/constants/api";

// 리뷰 아로마 정보 인터페이스
export interface ReviewAromaInfo {
    id: number;
    code: string;
    name: string;
    category: string;
    description: string;
}

// 리뷰 제품 정보 인터페이스
export interface ReviewProductInfo {
    productAltKey: string;
    productName: string;
    type: string;
    abv: number | null;
}

// 리뷰 이미지 정보 인터페이스
export interface ReviewImageInfo {
    altKey: string;
    imageUrl: string;
    createdAt: string;
}

// 리뷰 정보 인터페이스
export interface ReviewInfo {
    altKey: string;
    userAltKey: string;
    rating: number;
    sweetness: number;
    sourness: number;
    carbonation: number;
    aromaStrength: number;
    content: string;
    mood: string | null;
    companion: string | null;
    food: string | null;
    reviewDate: string;
    createdAt: string;
    reviewAromaInfoList: ReviewAromaInfo[];
    reviewProductInfo: ReviewProductInfo;
    reviewImageInfoList: ReviewImageInfo[];
}

// 페이지네이션 정보 인터페이스
export interface PaginationInfo {
    totalRecords: number;
    currentPage: number;
    totalPages: number;
    nextPage: number | null;
    prevPage: number | null;
}

// 리뷰 응답 인터페이스
export interface ReviewResponseData {
    reviewInfoList: ReviewInfo[];
    pagination: PaginationInfo;
}

// 정렬 타입
export type SortType = "NEW" | "OLD" | "HIGH_RATING" | "LOW_RATING";

// 술로그 리뷰 목록 조회
export const fetchSoolLogReviews = async (
    page = 0,
    size = 5,
    year?: number,
    month?: number,
    sortType: SortType = "NEW"
): Promise<ReviewResponseData> => {
    try {
        const params: Record<string, any> = {
            page,
            size,
            sortType
        };

        // 연도와 월이 있는 경우에만 파라미터에 추가
        if (year) params.year = year;
        if (month) params.month = month;

        const response = await api.get<ApiResponse<ReviewResponseData>>(API_ENDPOINTS.MY_REVIEWS, {
            params
        });
        return response.data.data;
    } catch (error) {
        console.error("Failed to fetch soollog reviews:", error);
        throw error;
    }
};

// 이미지 URL 생성 함수
export const getImageUrl = (imagePath: string): string => {
    // 이미 전체 URL인 경우 그대로 반환
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
        return imagePath;
    }
    // 그렇지 않으면 IMAGE_DOMAIN과 결합
    return `${API.IMAGE_DOMAIN}/${imagePath}`;
};

export default {
    fetchSoolLogReviews,
    getImageUrl
};
